// API
export const GET_AGREEMENTS_API = 'agreements/:type';
export const GET_SUBSCRIBER_AGREEMENTS_API = 'subscriber/agreements';
export const ACCEPT_SUBSCRIBER_AGREEMENTS_API = 'subscriber/agreements/accept';
export const DECLINE_SUBSCRIBER_AGREEMENTS_API =
	'subscriber/agreements/decline';

// Queries
export const QUERY_REGISTER_AGREEMENTS = 'QUERY_REGISTER_AGREEMENTS';
export const QUERY_SUBSCRIBER_AGREEMENTS = 'QUERY_SUBSCRIBER_AGREEMENTS';
export const QUERY_INVOICE_FORM_AGREEMENT = 'QUERY_INVOICE_FORM_AGREEMENT';
export const QUERY_VOD_PAYMENT_AGREEMENTS = 'QUERY_VOD_PAYMENT_AGREEMENTS';
export const QUERY_FINALIZE_AGREEMENTS = 'QUERY_FINALIZE_AGREEMENTS';
